import { FC } from 'react';

import { Address } from './components/Address';
import { Underground } from './components/Underground';
import { IGeoBlock } from './types';

import * as styles from './styles.css';

export const GeoBlock: FC<IGeoBlock> = props => {
  const { className, addressText, underground, subdomain } = props;

  return (
    <div className={className}>
      <Address addressText={addressText} />
      {underground && <Underground {...underground} className={styles['underground']} subdomain={subdomain} />}
    </div>
  );
};

GeoBlock.displayName = 'GeoBlock';
